import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import type { SubmitSamsReport } from "../../../schemas/sams";

const samsKeys = {
	landesverbaende: ["sams", "landesverbaende"] as const,
	reports: (tournamentId: string) => ["sams", "reports", tournamentId] as const,
};

// Admin-gated endpoints: a non-admin caller gets 403, so don't retry — the
// consumer treats an error/empty result as "reporting not available here".
export function useSamsLandesverbaende() {
	return useQuery({
		queryKey: samsKeys.landesverbaende,
		queryFn: () => clubApi.sams.landesverbaende(),
		retry: false,
	});
}

export function useSamsTournamentReports(tournamentId: string | null) {
	return useQuery({
		queryKey: samsKeys.reports(tournamentId ?? ""),
		queryFn: () => clubApi.sams.reports(tournamentId!),
		enabled: !!tournamentId,
		retry: false,
	});
}

export function useSubmitSamsReport() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (data: SubmitSamsReport) => clubApi.sams.submit(data),
		onSuccess: (_, { tournamentId }) =>
			qc.invalidateQueries({ queryKey: samsKeys.reports(tournamentId) }),
	});
}
